import React, { useMemo, useState } from "react";
import { buildAlertsForEvento, groupAlertsByPerson } from "../../domain/notificacionesEvento";
import { formatDate } from "../../domain/eventoDetalleUtils";

export function TabNotificaciones({ evento, personas = [], styles }) {
    const [query, setQuery] = useState("");
    const [horizon, setHorizon] = useState(180);
    const [estado, setEstado] = useState("all");

    // 1) Construcción (ya dedup dentro del dominio) + hidratación con catálogo
    const alerts = useMemo(() => {
        return buildAlertsForEvento(evento, Number(horizon), personas) || [];
    }, [evento, horizon, personas]);

    // 2) Filtros
    const filteredAlerts = useMemo(() => {
        const q = query.trim().toLowerCase();

        return alerts.filter((a) => {
            const text = `${a.personName || ""} ${a.label || ""} ${a.meta || ""}`.toLowerCase();
            if (q && !text.includes(q)) return false;

            if (
                estado !== "all" &&
                !(
                    (estado === "expired" && a.status === "expired") ||
                    (estado === "soon" && a.status === "soon") ||
                    (estado === "missing" && a.status === "missing")
                )
            ) {
                return false;
            }

            return true;
        });
    }, [alerts, query, estado]);

    // 3) Agrupar (con orden dentro del dominio)
    const groupedByPerson = useMemo(() => {
        return groupAlertsByPerson(filteredAlerts);
    }, [filteredAlerts]);

    return (
        <div className={styles["notif-view"]}>

            {groupedByPerson.length === 0 ? (
                <div className={styles.empty}>
                    <div className={styles.emoji}>🔔</div>
                    <h3>Sin notificaciones</h3>
                    <p>No hay caducidades (o faltas de fecha) en el rango seleccionado.</p>
                </div>
            ) : (
                <div className={styles["card-list"]}>
                    {groupedByPerson.map((grp) => (
                        <article key={grp.personId} className={`${styles.card} ${styles["person-card"]}`}>
                            <header className={styles["person-head"]}>
                                <div className={styles.avatar}>{(grp.personName?.[0] || "?").toUpperCase()}</div>
                                <div className={styles.title}>
                                    <div className={styles.name}>{grp.personName}</div>
                                    <div className={`${styles.muted} ${styles.small}`}>{grp.items.length} aviso(s)</div>
                                </div>
                            </header>

                            <div className={styles["person-body"]}>
                                <div className={styles["table-wrap"]}>
                                    <table className={`${styles.table} ${styles.responsive}`}>
                                        <thead>
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Detalle</th>
                                                <th>Fecha</th>
                                                <th>Días</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {grp.items.map((a) => (
                                                <tr key={a.id}>
                                                    <td data-label="Tipo">{a.label}</td>
                                                    <td data-label="Detalle" className={styles.muted}>
                                                        {a.meta || "—"}
                                                    </td>
                                                    <td data-label="Fecha">{formatDate(a.fecha)}</td>
                                                    <td data-label="Días">{a.daysLeft ?? "—"}</td>
                                                    <td data-label="Estado">
                                                        <span className={`${styles.pill} ${a.status === "expired" ? styles.danger : styles.warn}`}>
                                                            {a.status === "expired" ? "Vencida" : a.status === "soon" ? "Próxima" : "Sin fecha"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
}
